<template>
  <div class="c-clientwinelist">
    <v-row>
      <v-col>
        <div class="page-title">Liste des vins pour {{ clientName }}</div>
        <v-alert :value="!!error" type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          item-key="wine_id"
          hide-default-footer
          disable-pagination
          class="elevation-1 transparent"
        >
          <template v-slot:item="{ item }">
            <tr class="c-clientlist__tablerow">
              <td>{{ item._producer_name }}</td>
              <td>{{ item._color_name }}</td>
              <td>{{ item.data ? item.data.region: "" }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.data ? item.data.appellation: "" }}</td>
              <td>{{ item.data ? item.data.vintage : "" }}</td>

              <td>{{ item._enabled ? "Oui" : "Non" }}</td>

              <td class="justify-center layout px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="setItem(item)">
                      <v-icon color="teal">add</v-icon>
                    </v-btn>
                  </template>
                  <span>Activer</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="unsetItem(item)">
                      <v-icon color="red">close</v-icon>
                    </v-btn>
                  </template>
                  <span>Désactiver</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ErrorManagement from '@/mixins/ErrorManagement';
import RoleFiltering from '@/mixins/RoleFiltering';

import { CLIENT_WINE_LIST, CLIENT_WINE_SET, CLIENT_WINE_UNSET } from '@/store/actions/client';


export default {
  name: 'ClientList',

  props: {
    clientId: {
      type: Number,
      required: true
    }
  },

  mixins: [
    ErrorManagement,
    RoleFiltering
  ],

  components: {
  },

  data: () => ({
    loading: false,
    headers: [
      { text: 'Fournisseur', value: 'provider' },
      { text: 'Couleur du vin', value: 'color' },
      { text: 'Région', value: 'region' },
      { text: 'Nom du vin / domaine', value: 'name' },
      { text: 'Appellation', value: 'appellation' },
      { text: 'Millésime', value: 'vintage' },

      { text: 'Activé', value: 'enabled' },
      { text: 'Actions', value: 'action', sortable: false }
    ]
  }),

  computed: {
    ...mapState({
      items: state => state.client.wines,
      clientName: state => state.client.client.name
    })
  },

  mounted () {
    this.fetchData();
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },

  beforeRouteUpdate (to, from, next) {
    this.fetchData();
    next();
  },

  methods: {
    fetchData () {
      this.loading = true;
      this.$store.dispatch(CLIENT_WINE_LIST, this.clientId)
        .catch((err) => {
          this.setError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setItem (item) {
      this.$store.dispatch(CLIENT_WINE_SET, item.wine_id);
    },
    unsetItem (item) {
      this.$store.dispatch(CLIENT_WINE_UNSET, item.wine_id);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-clientlist {
  &__tablerow {
    cursor: pointer;
  }
}
</style>
